import { useState } from "react";
import { IScenarioNode } from "../../models/ILiveChatScenario";
import { countNodes } from "../../utils/scenarioUtils";

interface Props {
  node: IScenarioNode;
  busy: boolean;
  error: string;
  onClose: () => void;
  onDelete: (includeChildren: boolean) => void;
  onPark: () => void;
}

export default function DeleteScenarioNodeModal({ node, busy, error, onClose, onDelete, onPark }: Props) {
  const childCount = countNodes(node.children ?? []);
  const [confirmChildren, setConfirmChildren] = useState(false);
  const canDelete = childCount === 0 || confirmChildren;

  return (
    <div
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 1080, display: "flex", alignItems: "center", justifyContent: "center", backdropFilter: "blur(3px)", padding: 16 }}
      onClick={(e) => { if (e.target === e.currentTarget && !busy) onClose(); }}
    >
      <div style={{ background: "#fff", borderRadius: 20, padding: "24px 24px 20px", width: "min(96vw, 440px)", boxShadow: "0 8px 40px rgba(0,0,0,0.18)" }}>
        <div style={{ display: "flex", gap: 12, alignItems: "flex-start", marginBottom: 14 }}>
          <span style={{ width: 40, height: 40, borderRadius: 12, background: "#fef2f2", color: "#dc2626", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: "1.1rem" }}>
            <i className="bi bi-trash3-fill"></i>
          </span>
          <div>
            <div style={{ fontWeight: 800, fontSize: "1rem", color: "#111827" }}>Adımı sil</div>
            <div style={{ fontSize: ".84rem", color: "#4b5563", marginTop: 4 }}>
              <b>"{node.text}"</b> kalıcı olarak silinecek{childCount > 0 && <> ve altındaki <b>{childCount} adım</b> da gidecek</>}.
            </div>
          </div>
        </div>

        <div className="lcs-note lcs-note--warn" style={{ marginBottom: 12 }}>
          <i className="bi bi-lightbulb-fill"></i>
          <span>
            Silmek, bu adımların form gönderim kayıtlarını da siler. Sadece müşteriden gizlemek istiyorsanız <b>pasife almak</b> daha güvenlidir — istediğiniz an geri açabilirsiniz.
          </span>
        </div>

        {childCount > 0 && (
          <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: ".82rem", fontWeight: 600, color: "#374151", cursor: "pointer", marginBottom: 12 }}>
            <input type="checkbox" checked={confirmChildren} onChange={(e) => setConfirmChildren(e.target.checked)} />
            Alt adımlarıyla birlikte silmek istiyorum
          </label>
        )}

        {error && <div className="lcs-note lcs-note--error" style={{ marginBottom: 12 }}><i className="bi bi-exclamation-circle-fill"></i><span>{error}</span></div>}

        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", flexWrap: "wrap" }}>
          <button type="button" className="lcs-btn" onClick={onClose} disabled={busy}>Vazgeç</button>
          {node.isActive && (
            <button type="button" className="lcs-btn" onClick={onPark} disabled={busy}><i className="bi bi-pause-circle"></i>Pasife al</button>
          )}
          <button type="button" className="lcs-btn lcs-btn--danger" disabled={busy || !canDelete} onClick={() => onDelete(childCount > 0)}>
            {busy ? <span className="spinner-border spinner-border-sm"></span> : <i className="bi bi-trash3"></i>}Sil
          </button>
        </div>
      </div>
    </div>
  );
}
